/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyAhFo1ioVD4sU1QpYutOl5x_c9cR64rs6I',
    authDomain: 'dev-quaker-search.firebaseapp.com',
    databaseURL: 'https://dev-quaker-search.firebaseio.com',
    projectId: 'dev-quaker-search',
    storageBucket: 'dev-quaker-search.appspot.com',
    messagingSenderId: '902298442917',
  },
};

export const geocode = {
  config: {
      apiKey: 'AIzaSyD0aKH15FdCNSf9rkxZAMqDv511avEI3rk',
  },
};

export const googlePlaces = {
  config: {
      apiKey: 'AIzaSyA0T8cq-EUQpdjU67t22Cbt6u4f5oqDNxs',
      libraries: ['places', 'drawing'],
      region: 'US',
  },
};

export const staticMap = {
  config: {
      apiKey: 'AIzaSyAYC46p1ImBh4_xeDfqTKRegWX_H5D-hmk',
      urlBase: 'https://maps.googleapis.com/maps/api/staticmap',
  },
};

export const roadsApi = {
  config: {
      apiKey: 'AIzaSyB-Fv5wHge0zXI5m82mviF-kMEJIndW-T4',
  },
};

export const streetView = {
  config: {
      apiKey: 'AIzaSyA0T8cq-EUQpdjU67t22Cbt6u4f5oqDNxs',
  },
};

export const marketCheck = {
  config: {
    apiKey: 'vCZ1dagLildQG7ZuywJoATtpdYMRBL3B',
  }
};

export const sightHound = {
  config: {
    apiKey: 'VJWKxiqS9LrZjTPW14UJNTfTwxMbCD3UoZvf',
  }
}

export const gmaps = {
  config: {
    apiKey: 'AIzaSyA0T8cq-EUQpdjU67t22Cbt6u4f5oqDNxs',
  }
};
